"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackTypes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const icons_1 = require("../../icons");
const Text_1 = __importDefault(require("../../components/Text"));
const feedbackMessage_module_scss_1 = __importDefault(require("./feedbackMessage.module.scss"));
exports.feedbackTypes = ['error', 'warning'];
const FeedbackMessage = (_a) => {
    var { children, className = '', type = 'error', withIcon = true } = _a, textProps = __rest(_a, ["children", "className", "type", "withIcon"]);
    const Icon = type === 'error' ? icons_1.TimesCircleIcon : icons_1.AlertCircleIcon;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(className, feedbackMessage_module_scss_1.default.container, feedbackMessage_module_scss_1.default[`icon_${type}`]), children: [withIcon && ((0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(feedbackMessage_module_scss_1.default.icon, 'mr-2'), children: (0, jsx_runtime_1.jsx)(Icon, {}) })), (0, jsx_runtime_1.jsx)(Text_1.default, Object.assign({ className: feedbackMessage_module_scss_1.default.text }, textProps, { children: children }))] }));
};
exports.default = FeedbackMessage;
